import { UserRole, type User } from '@/types/global'
import {
  Ability,
  AbilityBuilder,
  createMongoAbility,
  PureAbility,
  type AbilityTuple,
  type AbilityClass,
  type MongoAbility,
  type MongoQuery
} from '@casl/ability'
import { context } from '.'

// export default function defineAbilityFor(
//   user: User
// ): MongoAbility<AbilityTuple<Actions, Subjects>, MongoQuery> {
//   const { can, cannot, build } = new AbilityBuilder(createMongoAbility)

//   if (user.halaqat_role === UserRole.ADMIN) {
//     can('manage', 'all') // read-write access to everything
//   } else {
//     can('read', 'all') // read-only access to everything
//   }

//   cannot('delete', 'Post', { published: true })

//   return build() as MongoAbility<AbilityTuple<Actions, Subjects>, MongoQuery>
// }

export const permissions = (user: User | null | undefined) => {
  const { can, cannot, build } = new AbilityBuilder<
    MongoAbility<AbilityTuple<Actions, Subjects>, any>
  >(createMongoAbility)

  const role = context === 'manarah_school' ? user?.halaqat_role : user?.bayen_role

  if (role === UserRole.ADMIN) {
    can('manage', 'Presence')
    can('create', 'Students')
    can('edit', 'Students')
    can('transfer', 'Students')
    can('manage', 'Absences')
    can('view', 'AdminStats')
    can('manage', 'Visits')
  }

  if (role !== UserRole.ADMIN) {
    cannot('edit', 'Students')
    cannot('manage', 'Absences')
  }

  return build()
}

type Actions = 'create' | 'manage' | 'edit' | 'view' | 'transfer'
type Subjects = 'Presence' | 'Students' | 'Sessions' | 'Absences' | 'AdminStats' | 'Visits'
